






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface Insertion {
    pigeDate: string;
}

@Component({ components: { } })
export default class PigeDate extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.pigeDate",
        ];
    }
}
